// =====================================================================
// codeScanne.js — le code d'un objet à partir de ce qu'un scanner a lu
// =====================================================================
// L'autocollant QR d'un objet porte une ADRESSE (https://…/accidents?scan=BS-01),
// pour que l'appareil photo d'un téléphone ouvre Zeus tout seul. Le lecteur laser
// du PDA et la caméra intégrée à Zeus lisent cette adresse ENTIÈRE : avant le
// 23-10-2026, l'écran cherchait alors un objet nommé « https://… » et répondait
// « Aucun objet ne porte le code ». Les codes sont tous en majuscules.
// Même règle côté serveur : backend/src/lib/code-scan.js.
// =====================================================================

export function codeScanne(brut) {
  const s = String(brut ?? '').trim();
  if (!s) return '';
  const param = s.match(/[?&]scan=([^&#\s]+)/i);
  if (param) {
    let c = param[1];
    try { c = decodeURIComponent(c); } catch { /* code tel quel */ }
    return c.trim().toUpperCase();
  }
  if (/^https?:\/\//i.test(s)) {
    // Adresse sans « ?scan= » : le dernier segment du chemin (…/BS-01).
    const segments = s.replace(/[?#].*$/, '').split('/').filter(Boolean).slice(2);
    return (segments.pop() || '').trim().toUpperCase();
  }
  return s.toUpperCase();
}
